var map = {
	"./arrow-white.svg": 82,
	"./arrow.svg": 83,
	"./close.svg": 84,
	"./correctibot.png": 31,
	"./correctibot_2.png": 30,
	"./correctiv-weekly.svg": 85,
	"./donat.png": 15,
	"./leaderboard.png": 27,
	"./leaderboard.svg": 86,
	"./negative.png": 29,
	"./positive.png": 28,
	"./profile.svg": 87,
	"./question1/article1.JPG": 88,
	"./question1/article2.jpg": 89,
	"./question1/ausnahme_map.jpg": 90,
	"./question1/fb-screenshot.jpg": 91,
	"./question1/gesetzentwurf.jpg": 92,
	"./question1/graph-1.svg": 93,
	"./question1/more-articles.jpg": 94,
	"./question1/more-videos.jpg": 95,
	"./question1/original-article.jpg": 96,
	"./question1/reichstag.jpg": 97,
	"./question1/video1.jpg": 98,
	"./question1/video2.jpg": 99,
	"./question1/video3.jpg": 100,
	"./question2/article1.jpg": 101,
	"./question2/article2.jpg": 102,
	"./question2/article3.jpg": 103,
	"./question2/image_search.jpg": 104,
	"./question2/original.jpg": 105,
	"./question2/trump_post.jpg": 106,
	"./question2/video1.jpg": 107,
	"./question3/article1.jpg": 108,
	"./question3/dashboard.jpg": 109,
	"./question3/original.jpg": 110,
	"./question3/video1.jpg": 111,
	"./question3/whatsapp.jpg": 112,
	"./question4/article1.jpg": 113,
	"./question4/article2.jpg": 114,
	"./question4/facebook.png": 115,
	"./question4/original.jpg": 116,
	"./question4/schilder.png": 117,
	"./question4/video1.jpg": 118,
	"./question5/article1.jpg": 119,
	"./question5/article2.jpg": 120,
	"./question5/doggo.jpg": 121,
	"./question5/original.jpg": 122,
	"./question5/screenshot1.jpg": 123,
	"./question6/5g.jpg": 124,
	"./question6/article1.jpg": 125,
	"./question6/article2.jpg": 126,
	"./question6/artikelbild.jpg": 127,
	"./question6/map.png": 128,
	"./question6/original.jpg": 129,
	"./question6/video1.jpg": 130,
	"./question6/video2.jpg": 131,
	"./question6/zitat.jpg": 132,
	"./question7/dpa.jpg": 133,
	"./question7/merkel_kalender.jpg": 134,
	"./question7/social_screens.jpg": 135,
	"./settings.svg": 136,
	"./start/dragdonat.jpg": 32,
	"./start/dragdonat.mov": 33,
	"./start/leftright.jpg": 34,
	"./start/leftright.mov": 35,
	"./start/results.jpg": 137,
	"./start/results.mov": 138,
	"./start/rightanswer.jpg": 25,
	"./start/rightanswer.mov": 36,
	"./start/wronganswer.mov": 37,
	"./user1.png": 17,
	"./user2.png": 21,
	"./user3.png": 22,
	"./video-play.png": 38
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20;